/**
 * lettered-landing.js
 * Handles: custom cursor, A–Z letter selector, dynamic price,
 * FAQ accordion, scroll reveal, and add-to-cart → checkout.
 */

(function () {
  'use strict';

  // ── CURSOR ──────────────────────────────────────────────────────────────
  const cursor = document.getElementById('ll-cursor');
  const ring   = document.getElementById('ll-cursor-ring');

  if (cursor && ring) {
    let mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', (e) => {
      mx = e.clientX;
      my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top  = my + 'px';
    });

    (function animRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animRing);
    })();

    document.querySelectorAll('.lettered-landing a, .lettered-landing button, .lettered-landing .faq-item, .lettered-landing .letter-btn').forEach((el) => {
      el.addEventListener('mouseenter', () => {
        cursor.style.width  = '18px';
        cursor.style.height = '18px';
        ring.style.width    = '52px';
        ring.style.height   = '52px';
      });
      el.addEventListener('mouseleave', () => {
        cursor.style.width  = '10px';
        cursor.style.height = '10px';
        ring.style.width    = '36px';
        ring.style.height   = '36px';
      });
    });
  }

  // ── VARIANT DATA ─────────────────────────────────────────────────────────
  // Injected by the Liquid section as a JSON script tag.
  let variantMap = {};
  const variantDataEl = document.getElementById('ll-variant-data');
  if (variantDataEl) {
    try {
      variantMap = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      console.warn('Lettered: could not parse variant data', e);
    }
  }

  // ── LETTER SELECTOR ──────────────────────────────────────────────────────
  const letters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const grid          = document.getElementById('ll-letter-grid');
  const selectedDisp  = document.getElementById('ll-selected-display');
  const productPreview = document.getElementById('ll-product-preview');
  const heroLetter    = document.getElementById('ll-hero-letter');
  const heroBgLetter  = document.getElementById('ll-hero-bg-letter');
  const finalBgText   = document.getElementById('ll-final-bg-text');
  const priceEl       = document.getElementById('ll-price');
  const priceWasEl    = document.getElementById('ll-price-was');
  const claimText     = document.getElementById('ll-claim-text');

  let selectedLetter = 'A';

  function updateLetter(l) {
    selectedLetter = l;

    if (selectedDisp) selectedDisp.innerHTML = 'You selected: <strong>' + l + '</strong>';
    if (finalBgText)  finalBgText.textContent = l;
    if (heroBgLetter) heroBgLetter.textContent = l;
    if (heroLetter)   heroLetter.textContent = l;

    if (productPreview) {
      productPreview.textContent = l;
      productPreview.style.transform = 'scale(1.15)';
      setTimeout(() => { productPreview.style.transform = 'scale(1)'; }, 300);
    }

    const variant = variantMap[l];
    if (variant) {
      if (priceEl)    priceEl.textContent    = variant.price;
      if (priceWasEl) priceWasEl.textContent = variant.compareAtPrice;
      if (priceWasEl) priceWasEl.style.display = variant.compareAtPrice ? '' : 'none';
      if (claimText)  claimText.textContent  = 'Claim My ' + l + ' Initial — ' + variant.price;
    }
  }

  if (grid) {
    letters.forEach((l) => {
      const btn = document.createElement('button');
      btn.className   = 'letter-btn' + (l === 'A' ? ' active' : '');
      btn.textContent = l;
      btn.type        = 'button';

      btn.addEventListener('click', () => {
        grid.querySelectorAll('.letter-btn').forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
        updateLetter(l);
      });

      grid.appendChild(btn);
    });

    // Initialise price display for 'A'
    updateLetter('A');
  }

  // ── ADD TO CART → CHECKOUT ───────────────────────────────────────────────
  const claimBtn = document.getElementById('ll-claim-btn');

  if (claimBtn) {
    claimBtn.addEventListener('click', async () => {
      const variant = variantMap[selectedLetter];

      if (!variant || !variant.id) {
        alert('Please select a letter first.');
        return;
      }

      const originalText = claimText ? claimText.textContent : '';
      claimBtn.disabled = true;
      if (claimText) claimText.textContent = 'Adding to cart…';

      try {
        const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Could not add to cart. Please try again.');
        }

        window.location.href = '/checkout';
      } catch (error) {
        claimBtn.disabled = false;
        if (claimText) claimText.textContent = originalText;
        alert(error.message);
      }
    });
  }

  // ── FAQ ACCORDION ────────────────────────────────────────────────────────
  document.querySelectorAll('.lettered-landing .faq-item').forEach((item) => {
    const q = item.querySelector('.faq-q');
    if (!q) return;

    q.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      // Close all others
      document.querySelectorAll('.lettered-landing .faq-item.open').forEach((openItem) => {
        openItem.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── SCROLL REVEAL ─────────────────────────────────────────────────────────
  const reveals  = document.querySelectorAll('.lettered-landing .reveal');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    { threshold: 0.12 }
  );

  reveals.forEach((el) => observer.observe(el));

  // Immediately reveal hero elements on load
  window.addEventListener('load', () => {
    document.querySelectorAll('.lettered-landing .hero .reveal').forEach((el, i) => {
      setTimeout(() => el.classList.add('visible'), i * 150);
    });
  });
})();
